<style>

.edit{
  position: fixed;
  left: 20px;
  bottom: 80px;
  z-index: 100;
}

.bg{
  background-color: #ccc;
  color: black;
  border-radius: 10px;
  box-shadow: 0 0 10px #333;
}
.pad{
  padding: 4px 6px 5px 6px;
}
</style>


<div class="edit">
  <div class="bg">
    <div class="pad">
      <slot></slot>
    </div>
  </div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let size = "small"; // or large

// allows a simple slide out to happen from underneath the button
// the slideout content is contained in a <slot></slot>
export let expandable = false;

// allows the simple slide out to be permanently shown on screen
// the idea is for a quick [tomorrow][today][/] editor
// on top of events
export let quickShown = true;


function quickHelper() {
  if (expandable == true) quickShown = !quickShown;
  dispatch("click");
}

</script>